// Resolves a phase to a stable identity key. Used by:
//   - MaterialsPanel: AutocompleteFormField option-comparison key on the
//     per-row "Phase Name" dropdown.
//   - ProjectDetailsPanel: phase-removal cascade — clear the `phase` ref on
//     any projectMaterialTotal whose phase identity is no longer in the
//     active set (mirrors the legacy form).
// Mirrors the legacy form's identity resolution; not re-implemented per panel.
export const getPhaseIdentityKey = (
  phase:
    | { id?: string | null; name?: string | null; code?: string | null }
    | null
    | undefined,
): string | null => {
  if (!phase) return null;
  if (phase.id) return `id:${phase.id}`;
  const phaseName = phase.name ?? '';
  const phaseCode = phase.code ?? '';
  if (!phaseName && !phaseCode) return null;
  return `tmp:${phaseName}::${phaseCode}`;
};
